export const getYearsOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) =>
    (currentYear - 2 + index).toString(),
  );
  return years;
};
